var map = {
	"./smile-1.svg": 44625,
	"./smile-2.svg": 54075,
	"./smile-3.svg": 23103,
	"./smile-4.svg": 31364,
	"./smile-5.svg": 15256,
	"./star-1.svg": 92481,
	"./star-2.svg": 75486,
	"./star-3.svg": 43280,
	"./star-4.svg": 48939,
	"./star-5.svg": 20123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92617;